import { motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { toggleLanguage } from "../store/features/languageSlice";

const LanguageToggle = () => {
  const lang = useSelector((state) => state.language.lang);
  const dispatch = useDispatch();

  const isEN = lang === "en";

  return (
    <div className="flex items-center gap-2 rounded-full px-2 py-1 text-xs">
      <div
        onClick={() => dispatch(toggleLanguage())}
        className="relative w-20 h-9 cursor-pointer rounded-full bg-black border border-gray-700 flex items-center px-1 overflow-hidden"
      >
        {/* SLIDING INDICATOR */}
        <motion.div
          layout
          transition={{
            type: "spring",
            stiffness: 420,
            damping: 28,
            mass: 0.6,
          }}
          className="absolute top-1 h-7 w-9 rounded-full bg-neonYellow shadow-[0_0_12px_rgba(230,255,26,0.6)]"
          style={{
            left: isEN ? "4px" : "40px",
          }}
        />

        {/* LABELS */}
        <div className="relative z-10 flex justify-between w-full px-2 text-xs font-semibold  ">
          <motion.span
            animate={{ color: isEN ? "#000000" : "#9ca3af" }}
            transition={{ duration: 0.25 }}
            className={isEN ? "animate-neonFlicker" : ""}
          >
            EN
          </motion.span>

          <motion.span
            animate={{ color: !isEN ? "#000000" : "#9ca3af" }}
            transition={{ duration: 0.25 }}
            className={!isEN ? "animate-neonFlicker" : ""}
          >
            VI
          </motion.span>
        </div>
      </div>
    </div>
  );
};

export default LanguageToggle;
